import styled, { createGlobalStyle } from 'styled-components';

export const StyledDesktopMenu = styled.nav`
  --ion-background-color: transparent;
  background: var(--allie-color-menu);
  top: 0;
  bottom: 0;
  height: 100%;
  left: 0;
  width: 60px;
  transition: width 0.2s linear;
  transform: translateZ(0) scale(1, 1);
  box-shadow: 1px 0 15px rgba(0, 0, 0, 0.07);
  opacity: 1;
  z-index: 9;
  display: block;
  cursor: pointer;

  &.expanded {
    width: 290px;
    overflow-y: auto;
    background: var(--allie-color-menu);
    opacity: 1;
    cursor: auto;
  }

  .menu-header {
    padding: 0 12px;
    margin: 16px 0;
    box-sizing: border-box;
    height: 48px;
    display: flex;
    position: relative;

    &::before {
      content: '';
      position: absolute;
      bottom: -17px;
      left: 20%;
      width: 60%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }
  }

  .icon-button {
    background: var(--allie-menu-button-grey);
    border-radius: var(--allie-radius-md);
    display: none;

    &::part(native) {
      background: var(--allie-menu-button-grey);
      border-radius: var(--allie-radius-md);
      border-color: var(--allie-menu-button-grey);
    }
  }

  .item-level-0:not(:first-of-type) {
    position: relative;
    color: white;
    &::before {
      content: '';
      position: absolute;
      bottom: -16px;
      left: 5%;
      width: 90%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }

    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      left: 20%;
      width: 60%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }
  }

  .menu-link-group {
    color: white;
    &::after {
      display: block;
      content: '';
      position: absolute;
      top: 0;
      left: 20%;
      width: 60%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }
  }

  ion-item {
    --inner-padding-end: 0px;

    .menu-link-group {
      display: none;
    }

    &::part(native) {
      padding: 0 0 0 21px;
    }

    ion-icon {
      color: white;
      margin-inline-end: 0;
      width: 16px;
      height: 16px;
      margin-inline-start: 0;
      color: var(--ion-color-primary-contrast);
      --color: var(--ion-color-primary-contrast);

      &:last-child {
        width: 12px;
        height: 12px;
        display: none;
      }
    }
  }

  .item-level-0 {
    ion-icon {
      &:last-child {
        width: 16px;
        height: 16px;
        display: block;
      }
    }
  }

  .scrollable {
    max-height: 60vh;
    overflow-y: auto;
    overflow-x: hidden;

    &::-webkit-scrollbar {
      width: 0px;
      background: transparent;
    }

    &:hover::-webkit-scrollbar {
      width: 8px;
    }
  }

  .leaf-item {
    .menu-link {
      color: white;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      color: rgba(var(--ion-color-primary-contrast-rgb), 0.5);
    }

    &.selected {
      .menu-link {
        color: var(--ion-color-primary-contrast);
        --background: none;
        font-weight: 600;
      }
    }
  }

  .typography {
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
    color: white;
  }

  .accordion-level-1 {
    position: relative;
    color: white;
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 20%;
      width: 60%;
      height: 1px;
      background-color: var(--allie-color-menu-arrow);
    }
  }

  .root-menu-item {
    color: var(--ion-color-primary-contrast);
    --color: var(--ion-color-primary-contrast);

    &.selected {
      --color: var(--ion-color-primary-contrast);
      --background: none;
    }

    .icon-badge-wrapper {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }

    .badge {
      position: absolute;
      top: 16px;
      right: -16px;
      font-size: 10px;
      min-width: 12px;
      height: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
      padding: 3px;
    }

    .icon-badge-wrapper > svg,
    .icon-badge-wrapper > ion-icon {
      position: relative;
      z-index: 0;
    }
  }

  &.expanded {
    .menu-link-group {
      &::before,
      &::after {
        display: none;
      }
    }

    .icon-button {
      display: block;
    }

    .item-level-2 {
      position: relative;
      padding-left: 30px;

      &::before {
        content: '';
        position: absolute;
        left: 25px;
        top: 0;
        bottom: 0;
        width: 1px;
        border-left: 1px dotted var(--allie-color-menu-arrow);
      }

      &::after {
        content: '';
        position: absolute;
        left: 25px;
        top: 50%;
        width: 15px;
        height: 1px;
        background-color: var(--allie-color-menu-arrow);
        clip-path: polygon(0 0, 100% 50%, 0 100%);
      }

      ion-icon {
        width: 0;
      }
    }

    ion-item {
      &::part(native) {
        padding: 0 12px;
      }

      .menu-link-group {
        display: block;
        padding-left: 8px;
      }

      ion-icon:last-child {
        width: 12px;
        height: 12px;
        display: block;
      }
    }

    .logo {
      width: 185px;

      div {
        display: block;
      }
    }

    .logo-img {
      height: 32px;
    }

    .non-icon-style {
      position: relative;
      padding-left: 25px;

      #empty-icon-menu {
        display: none;
      }

      &::before {
        content: '';
        position: absolute;
        left: 25px;
        top: 0;
        bottom: 0;
        width: 1px;
        background-color: var(--allie-color-menu-arrow);
      }

      &::after {
        content: '';
        position: absolute;
        left: 25px;
        top: 50%;
        width: 15px;
        height: 1px;
        background-color: var(--allie-color-menu-arrow);
        clip-path: polygon(0 0, 100% 50%, 0 100%);
      }
    }

    .menu-header::before {
      bottom: -16px;
      left: 5%;
      width: 90%;
    }

    .item-level-0::before,
    .item-level-0::after {
      display: none;
    }

    .selected {
      background: #1f242f;
      border-radius: 8px;
      font-weight: 800;
    }

    ion-label {
      margin-top: 0;
      margin-bottom: 0;
      padding-top: 8px;
      padding-bottom: 8px;
    }

    .menu-margin {
      margin: 4px 8px;
    }
  }

  .logo {
    display: flex;
    gap: 8px;
    align-items: center;
    overflow: hidden;

    div {
      display: none;
    }

    &::after {
      content: '';
      clear: both;
    }

    &-img {
      height: 32px;
      flex-shrink: 0;
    }
  }

  .scrollbar {
    width: 100%;
    flex: 1;
    overflow: auto;

    .list-menu {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
  }
`;

export const GlobalStyle = createGlobalStyle`
  .main-router:has(.main-menu-desktop) {
    display: flex;
  }
`;
